<template>
    <div class="apply-admission">
        <div class="apply-admission-wrap bg-dark accent-primary-bs bd-type1 accent-primary-bd">
            <div class="apply-admission-inner">
                <h2 class="title text-center">
                    <span>Signing you in�</span>
                </h2>
                <div class="caption text-center">
                    Please wait.
                </div>

                <div v-if="errorMessage" class="alert alert-danger" style="text-align: center; margin-top: 20px;">
                    {{ errorMessage }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getMsalInstance, clearEntraConfiguration } from '../../auth/entraMsal'

    export default {
        name: 'AuthCallback',
        data() {
            return {
                errorMessage: null
            }
        },
        computed: {
            siteDesign() {
                return this.$store.state.siteDesign
            }
        },
        async mounted() {
            try {
                const idToken = sessionStorage.getItem('entraIdToken')

                if (!idToken) {
                    this.errorMessage = 'No Entra sign-in response was found. Please click "Sign in with Microsoft" again.'
                    this.$router.replace({ name: 'Login' })
                    return
                }

                sessionStorage.removeItem('entraIdToken')
                const userState = await this.web('/auth/login-entra', 'Signing you in', { idToken })
                this.$store.commit('setUserState', userState)

                //const site = await this.web('/sites/' + userState.user.siteId, 'Loading Site Design')
                //const parsed = JSON.parse(site.siteDesign)
                //this.$store.commit('setDesign', parsed)

                clearEntraConfiguration()
                this.$router.replace({ name: 'Dashboard' })
            }
            catch (error) {
                console.error(error)
                this.errorMessage = error && error.message ? error.message : String(error)
                this.$router.replace({ name: 'Login' })
            }
        }
    }
</script>